module.exports = __webpack_public_path__ + "static/media/undraw_Mail_sent_qwwx_blue.86aebd44.svg";